// Unified requests API (read-only): GET /api/auth/requests, /:source/:id, /meta.
// Mutations are NOT here: every action keeps using its own system's API
// (utils/api/actions.js, ludDashboard.js, applications.js).
import config from "../../config.json";

const BASE = `${config.BASE_AUTH_API}requests`;

export class UnifiedRequestsError extends Error {
  constructor(message, { status = 0, code = null } = {}) {
    super(message);
    this.name = "UnifiedRequestsError";
    this.status = status;
    this.code = code;
  }
}

async function get(path, token, signal) {
  let response;
  try {
    response = await fetch(`${BASE}${path}`, {
      method: "GET",
      headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
      signal,
    });
  } catch (error) {
    if (error?.name === "AbortError") throw error;
    throw new UnifiedRequestsError("Network error", { status: 0, code: "NETWORK" });
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new UnifiedRequestsError(data.message || "Request failed", { status: response.status, code: data.code || null });
  }
  return data;
}

// Empty values are not sent, so the URL only carries what is really filtered.
export const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "" || value === false) return;
    query.set(key, String(value));
  });
  const text = query.toString();
  return text ? `?${text}` : "";
};

export const listUnifiedRequestsAPI = (token, params, { signal } = {}) => get(buildQuery(params), token, signal);
export const getUnifiedRequestAPI = (token, source, id, { signal } = {}) =>
  get(`/${encodeURIComponent(source)}/${encodeURIComponent(id)}`, token, signal).then((data) => data.request);
export const getUnifiedRequestsMetaAPI = (token, { signal } = {}) => get("/meta", token, signal);
